import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-punch",
  "use": "icon-punch-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-punch\">\r\n<path d=\"M12 1C8.14 1 5 4.14 5 8C5 12.17 9.42 17.92 11.24 20.11C11.64 20.59 12.37 20.59 12.77 20.11C14.58 17.92 19 12.17 19 8C19 4.14 15.86 1 12 1ZM15 9H13V11C13 11.55 12.55 12 12 12C11.45 12 11 11.55 11 11V9H9C8.45 9 8 8.55 8 8C8 7.45 8.45 7 9 7H11V5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V7H15C15.55 7 16 7.45 16 8C16 8.55 15.55 9 15 9Z\" />\r\n<ellipse cx=\"12\" cy=\"22.5\" rx=\"5\" ry=\"0.5\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol